import React from "react";
import PropTypes from "prop-types";
import { Button, Icon, Label, Checkbox, Form } from "semantic-ui-react";
import { SortableElement } from "react-sortable-hoc";
import { get, isEmpty, find, filter, map, isArray, includes } from "lodash";

// Components
import Input from "@Components/Input";
import FileManager from "@Components/FileManager";
import TextAreaInput from "@Components/TextArea";
// import UploadFile from "@Components/uploadFile";
import DragHandle from "@Features/ChatsBots/components/DragHandle";
import SortableOptionsList from "../SortableOptionsList";
// import Text from "@Components/Text";

// Styles
import styles from "./styles.module.css";

const SortableStageItem = SortableElement(
	({
		stage,
		position,
		stages,
		setStages,
		updateStageName,
		updateOption,
		isRemove,
		addOptionToStage,
		manualSortStage,
		errors,
		modalOption,
		actionsList,
		warningMinutes,
		timeoutMinutes,
	}) => {
		const getErrors = (stageId, name) => {
			const errorObjet = find(errors.stagesError, { id: stageId });
			const currentError = get(errorObjet, "error", {});
			const error = get(currentError, name, "");
			return error;
		};

		const moveOptionInStage = (oldIndex, newIndex, stageId) => {
			if (oldIndex === newIndex) return;

			setStages((prevStages) => {
				return prevStages.map((s) => {
					if (s.id === stageId) {
						const optionsCopy = [...s.options];
						const [movedOption] = optionsCopy.splice(oldIndex, 1);
						optionsCopy.splice(newIndex, 0, movedOption);
						const reorderedOptions = optionsCopy.map((opt, idx) => {
							return { ...opt, order: idx + 1 };
						});
						return { ...s, options: reorderedOptions };
					}
					return s;
				});
			});
		};

		const renderStageErrors = () => {
			const stageError = find(errors?.stagesError, { id: stage.id });
			const errorData = get(stageError, "error", {});

			if (!isEmpty(errorData.name)) {
				return (
					<Label basic color="red" size="tiny" className={styles.inlineErrorLabel}>
						{errorData.name}
					</Label>
				);
			}

			if (!isEmpty(errorData.text)) {
				return (
					<Label basic color="red" size="tiny" className={styles.inlineErrorLabel}>
						{errorData.text}
					</Label>
				);
			}

			if (!isEmpty(errorData.options)) {
				return (
					<Label basic color="red" size="tiny" className={styles.inlineErrorLabel}>
						{errorData.options}
					</Label>
				);
			}
			if (!isEmpty(errorData.buttonLabel)) {
				return (
					<Label basic color="red" size="tiny" className={styles.inlineErrorLabel}>
						{errorData.buttonLabel}
					</Label>
				);
			}
			if (!isEmpty(errorData.header)) {
				return (
					<Label basic color="red" size="tiny" className={styles.inlineErrorLabel}>
						{errorData.header}
					</Label>
				);
			}
			if (!isEmpty(errorData.footer)) {
				return (
					<Label basic color="red" size="tiny" className={styles.inlineErrorLabel}>
						{errorData.footer}
					</Label>
				);
			}
			const optionErrors = filter(errors?.optionError, { stageId: stage.id });

			if (!isEmpty(optionErrors)) {
				return map(optionErrors, ({ optionId, error }) => {
					if (!isEmpty(error.label)) {
						return (
							<Label key={`opt-error-${optionId}-label`} basic color="red" size="tiny" className={styles.inlineErrorLabel}>
								{error.label}
							</Label>
						);
					}
					if (!isEmpty(error.action)) {
						return (
							<Label key={`opt-error-${optionId}-action`} basic color="red" size="tiny" className={styles.inlineErrorLabel}>
								{error.action}
							</Label>
						);
					}
					return null;
				});
			}
			return null;
		};

		const effectiveBotWarning = Number(stage?.botWarning ?? warningMinutes ?? 0);
		const effectiveBotTimeout = Number(stage?.botTimeout ?? timeoutMinutes ?? 0);

		const isImageUri = (u) => {
			return typeof u === "string" && (/^data:image\//.test(u) || /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(u));
		};

		const getImageUris = (uri) => {
			return isArray(uri)
				? filter(uri, (u) => {
						return isImageUri(u);
				  })
				: [];
		};

		const imageUris = getImageUris(stage.uri);
		const rawStageTypeOptions = [
			{ key: "Text", text: "Numérico", value: "Text" },
			{ key: "Image", text: "Numérico con Imagen", value: "Image" },
			{ key: "Button", text: "Boton", value: "Button" },
			{ key: "buttonUri", text: "Boton URL", value: "buttonUri" },
			{ key: "buttonPhone", text: "Boton Teléfono", value: "buttonPhone" },
			{ key: "buttonFlow", text: "Boton Flow", value: "buttonFlow" },
			{ key: "List", text: "Lista", value: "List" },
		];

		const stageTypeOptions =
			stage.options?.length > 3
				? rawStageTypeOptions.filter((opt) => {
						return opt.value !== "Button";
				  })
				: rawStageTypeOptions;

		const currentStageType =
			stage.type &&
			rawStageTypeOptions.some((o) => {
				return o.value === stage.type;
			})
				? stage.type
				: "Text";

		return (
			<div className={styles.container}>
				<div className={styles.subContainerHeader}>
					<div className={styles.dragHandle}>
						<DragHandle disabled={modalOption === "Watch"} />
					</div>
					<div className={styles.contentIconDeleteStages}>
						<Icon
							name="trash alternate outline"
							disabled={modalOption === "Watch"}
							onClick={() => {
								return isRemove(stage.id, "stage", 0, 0, stage, {});
							}}
							className={styles.iconDeleteStages}
						/>
					</div>
					<div className={styles.titleContainer}>
						<strong className={styles.title}>Menú:</strong>
						<span className={styles.classDinamName}>
							{" "}
							{stage.name} - {stage.id}{" "}
						</span>
					</div>

					<div className={styles.stageActiveToggle}>
						<Checkbox
							toggle
							label={stage.isActive ?? true ? "Activo" : "Inactivo"}
							checked={stage.isActive ?? true}
							disabled={modalOption === "Watch"}
							onChange={(_, { checked }) => {
								updateStageName(stage.id, "isActive", checked);
							}}
						/>
					</div>

					<div>
						<Button
							className={`${styles.headerButton} ${position === 0 ? styles.headerButtonDisabled : ""}`}
							disabled={position === 0 || modalOption === "Watch"}
							onClick={() => {
								if (position > 0) {
									manualSortStage({ oldIndex: position, newIndex: position - 1 });
								}
							}}>
							<Icon name="minus" disabled={modalOption === "Watch"} />
						</Button>
					</div>
					<input type="text" value={position + 1} className={styles.idBox} readOnly />
					<Button
						className={`${styles.headerButton} ${position === stages.length - 1 ? styles.headerButtonDisabled : ""}`}
						disabled={position === stages.length - 1 || modalOption === "Watch"}
						onClick={() => {
							if (position < stages.length - 1) {
								manualSortStage({ oldIndex: position, newIndex: position + 1 });
							}
						}}>
						<Icon name="plus" disabled={modalOption === "Watch"} />
					</Button>
					<div className={styles.headerErrorsContainer}>{renderStageErrors()}</div>
					<Icon
						name={stage.isOpen ? "angle down" : "angle up"}
						onClick={() => {
							setStages(
								map(stages, (item) => {
									return item.id === stage.id ? { ...item, isOpen: !item.isOpen } : item;
								})
							);
						}}
						className={`${styles.toggleIcon} ${styles.toggleRight}`}
					/>
				</div>

				{stage.isOpen && (
					<div className={styles.containerBody}>
						<div className={styles.stageButton}>
							<div className={styles.stage}>
								<div className={styles.inputStage}>
									<Input
										placeholder="Nombre"
										value={stage.name}
										disabled={modalOption === "Watch"}
										maxLength={currentStageType === "Button" ? 20 : 24}
										label={
											<span className={styles.classNameLabel}>
												Nombre:<span className={styles.requiredAsterisk}>*</span>
											</span>
										}
										onChange={(e) => {
											return updateStageName(stage.id, "name", e.target.value);
										}}
									/>
									{!isEmpty(getErrors(stage.id, "name")) && (
										<Label basic color="red" className={styles.errorLabel}>
											{getErrors(stage.id, "name")}
										</Label>
									)}
								</div>
								<div className={styles.inputStage}>
									<span className={styles.classNameLabel}>Tipo:</span>
									<Form.Dropdown
										selection
										options={stageTypeOptions}
										value={currentStageType}
										disabled={modalOption === "Watch"}
										onChange={(e, { value }) => {
											updateStageName(stage.id, "type", value);
											if (value === "Text") {
												updateStageName(stage.id, "uri", []);
											}
										}}
									/>
								</div>
								<div className={styles.image}>
									{includes(["Image", "Button"], currentStageType) && (
										<div className={styles.image}>
											<FileManager
												images={imageUris}
												setImages={(nextImages) => {
													const onlyImages = Array.isArray(nextImages) ? nextImages.filter(isImageUri) : [];
													updateStageName(stage.id, "uri", onlyImages);
												}}
												disabled={modalOption === "Watch"}
											/>
										</div>
									)}
								</div>
							</div>
						</div>
						<div className={styles.containerTime}>
							<div className={styles.timeWar}>
								<span className={styles.text}>Tiempo de Aviso:</span>
								<Input
									type="number"
									min="0"
									icon="time"
									name="botWarning"
									placeholder="Minutos (15)"
									autoComplete="off"
									disabled={modalOption === "Watch"}
									value={String(effectiveBotWarning)}
									onChange={(e) => {
										const next = e.target.value === "" ? "" : Number(e.target.value);
										updateStageName(stage.id, "botWarning", next);
									}}
									error={
										!isEmpty(errors.botWarning) && {
											content: errors.botWarning,
											pointing: "above",
											className: styles.inputError,
										}
									}
								/>
							</div>

							<div className={styles.timeWar}>
								<span className={styles.text}>Tiempo de Timeout:</span>
								<Input
									type="number"
									min="0"
									icon="time"
									name="botTimeout"
									placeholder="Minutos (15)"
									autoComplete="off"
									disabled={modalOption === "Watch"}
									value={String(effectiveBotTimeout)}
									onChange={(e) => {
										const next = e.target.value === "" ? "" : Number(e.target.value);
										updateStageName(stage.id, "botTimeout", next);
									}}
									error={
										!isEmpty(errors.botTimeout) && {
											content: errors.botTimeout,
											pointing: "above",
											className: styles.inputError,
										}
									}
								/>
							</div>
							{/* {!hasImages && (
								<div>
									<Text className={styles.text}>Cargar Archivo (PDF, Video o Audio)</Text>
									<UploadFile
										document={fileUri}
										setDocument={(val) => {
											if (val) updateStageName(stage.id, "uri", [val]);
											else updateStageName(stage.id, "uri", []);
										}}
										accept=".pdf,.mp4,.mp3"
										disabled={modalOption === "Watch"}
									/>
									{!isEmpty(errors.document) && (
										<Label basic color="red" className={styles.errorLabel}>
											{errors.document}
										</Label>
									)}
								</div>
							)} 
								*/}
						</div>

						<div className={styles.textArea}>
							<div className={styles.textAreaHeader} />
							<TextAreaInput
								label="Mensaje:"
								name="text"
								value={stage.text}
								placeholder="Escribe el mensaje"
								onChange={(e) => {
									return updateStageName(stage.id, "text", e.target.value);
								}}
								disabled={modalOption === "Watch"}
								error={!isEmpty(getErrors(stage.id, "text")) ? getErrors(stage.id, "text") : ""}
								minRows={1}
								showCount
								maxLength={1024}
								showRequired
							/>
						</div>

						{includes(["List", "buttonUri", "buttonPhone"], currentStageType) && (
							<div className={styles.timeWar}>
								<span className={styles.text}>Button Label:</span>
								<Input
									placeholder="Texto del botón"
									value={stage.buttonLabel || ""}
									disabled={modalOption === "Watch"}
									onChange={(e) => {
										if (e.target.value.length <= 20) {
											updateStageName(stage.id, "buttonLabel", e.target.value);
										}
									}}
								/>
							</div>
						)}

						{includes(["buttonUri", "buttonPhone"], currentStageType) && (
							<div className={styles.timeWar}>
								<span className={styles.text}>Button Value:</span>
								<Input
									placeholder={currentStageType === "buttonUri" ? "URL (Ej: https://...)" : "Teléfono (Ej: +123...)"}
									value={stage.buttonUri || ""}
									disabled={modalOption === "Watch"}
									onChange={(e) => {
										updateStageName(stage.id, "buttonUri", e.target.value);
									}}
								/>
							</div>
						)}

						{!includes(["buttonUri", "buttonPhone"], currentStageType) && (
							<>
								<div className={styles.timeWar}>
									<span className={styles.text}>Header:</span>
									<Input
										placeholder="Texto de encabezado"
										value={stage.header || ""}
										disabled={modalOption === "Watch"}
										onChange={(e) => {
											if (e.target.value.length <= 60) {
												updateStageName(stage.id, "header", e.target.value);
											}
										}}
									/>
								</div>

								<div className={styles.timeWar}>
									<span className={styles.text}>Footer:</span>
									<Input
										placeholder="Texto de pie de página"
										value={stage.footer || ""}
										disabled={modalOption === "Watch"}
										onChange={(e) => {
											if (e.target.value.length <= 60) {
												updateStageName(stage.id, "footer", e.target.value);
											}
										}}
									/>
								</div>
							</>
						)}

						{!includes(["buttonUri", "buttonPhone"], currentStageType) && (
							<>
								<div className={styles.containerOptions}>
									<SortableOptionsList
										options={stage.options}
										stageId={stage.id}
										moveOption={(oldIndex, newIndex) => {
											return moveOptionInStage(oldIndex, newIndex, stage.id);
										}}
										stages={stages}
										stage={stage}
										updateOption={updateOption}
										isRemove={isRemove}
										onSortEnd={(params) => {
											return moveOptionInStage(params.oldIndex, params.newIndex, stage.id);
										}}
										useDragHandle
										helperClass="sortableHelper"
										errors={errors}
										modalOption={modalOption}
										actionsList={actionsList}
									/>
								</div>

								{!isEmpty(getErrors(stage.id, "options")) && (
									<Label basic color="red" className={styles.errorLabel}>
										{getErrors(stage.id, "options")}
									</Label>
								)}

								<div className={styles.buttonContainer}>
									<Button
										color="green"
										onClick={() => {
											return addOptionToStage(stage.id);
										}}
										className={styles.button}
										disabled={modalOption === "Watch"}>
										<Icon name="plus" /> Agregar Opción
									</Button>
								</div>
							</>
						)}
					</div>
				)}
			</div>
		);
	}
);

SortableStageItem.propTypes = {
	stage: PropTypes.object.isRequired,
	position: PropTypes.number.isRequired,
	stages: PropTypes.array.isRequired,
	setStages: PropTypes.func.isRequired,
	updateStageName: PropTypes.func.isRequired,
	addOptionToStage: PropTypes.func.isRequired,
	updateOption: PropTypes.func.isRequired,
	isRemove: PropTypes.func.isRequired,
	errors: PropTypes.object,
	images: PropTypes.array,
	updateStageImage: PropTypes.func,
	manualSortStage: PropTypes.func.isRequired,
	modalOption: PropTypes.string,
	actionsList: PropTypes.object,
	warningMinutes: PropTypes.number,
	timeoutMinutes: PropTypes.number,
};

export default SortableStageItem;
